module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0010.jpg?v=48abcae9";